import { User as UserIcon, Users as TeamIcon } from 'lucide-react';
import { components, OptionProps } from 'react-select';

import {
  Option,
  Options,
  PortainerSelect,
} from '@@/form-components/PortainerSelect';

interface Props<T> {
  options: Options<T | null>;
  value: T;
  onChange: (value: T) => void;
  getOptionValue: (value: T | null) => string;
  'data-cy': string;
}

type UserTeamValue = { Type: 'user' | 'team' | ''; Name: string };

export function SingleUserTeamSelector<T extends UserTeamValue>({
  options,
  value,
  onChange,
  getOptionValue,
  'data-cy': dataCy,
}: Props<T>) {
  return (
    <PortainerSelect<T | null>
      options={options}
      value={value}
      onChange={onChange}
      data-cy={dataCy}
      getOptionValue={getOptionValue}
      components={{
        Option: OptionComponent,
      }}
      bindToBody
    />
  );
}

function OptionComponent<T extends UserTeamValue | null>({
  data,
  ...props
}: OptionProps<Option<T>, false>) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.Option data={data} {...props}>
      <Label option={data} />
    </components.Option>
  );
}

function Label<T extends UserTeamValue | null>({
  option,
}: {
  option: Option<T>;
}) {
  if (option.value === null) {
    return <span>{option.label}</span>;
  }

  const Icon = option.value.Type === 'user' ? UserIcon : TeamIcon;

  return (
    <div className="flex items-center gap-1">
      <Icon />
      <span>{option.value.Name}</span>
    </div>
  );
}
